module.exports = __webpack_public_path__ + "static/media/icon_search.2ff54e7b.svg";